export default {"src":"/_next/static/media/shield-cat.1c748422.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};